import {
  all,
  call,
  takeLatest,
} from 'redux-saga/effects';

import {
  getBusinessLines,
  getPlainBusinessLines,
  createBusinessLine,
  editBusinessLine,
  deleteBusinessLine,
  getInterests,
  getPlainInterests,
  createInterest,
  editInterest,
  deleteInterest,
  getCountries,
  getCities,
  getPlainLanguagesSpoken,
  getLanguagesSpoken,
  createLanguageSpoken,
  editLanguageSpoken,
  deleteLanguageSpoken,
} from 'api/dictionaries';
import { DICTIONARIES_ACTION_TYPES } from 'store/actions/dictionaries.actions';
import { VERIFIED } from 'pages/Dictionaries/constants';

function* loadPlainBusinessLinesFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data } = yield call(getPlainBusinessLines);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadBusinessLinesFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getBusinessLines, payload);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e.response.data);
  }
}

function* createBusinessLineFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(createBusinessLine, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editBusinessLineFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { id, ...data } = payload;
    const { data: response } = yield call(editBusinessLine, id, data);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteBusinessLineFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(deleteBusinessLine, payload);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* verifyBusinessLineFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { id, names } = payload;
    const { data: response } = yield call(editBusinessLine, id, { status: VERIFIED, names });
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadPlainInterestsFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data } = yield call(getPlainInterests);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadInterestsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getInterests, payload);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e.response.data);
  }
}

function* createInterestFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(createInterest, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editInterestFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { id, ...data } = payload;
    const { data: response } = yield call(editInterest, id, data);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteInterestFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(deleteInterest, payload);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* verifyInterestFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { id, names } = payload;
    const { data: response } = yield call(editInterest, id, { status: VERIFIED, names });
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function * loadPlainLanguagesSpokenFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data: response } = yield call(getPlainLanguagesSpoken);
    resolve(response);
  } catch (e) {
    reject(e);
  }
}

function* loadLanguagesSpokenFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getLanguagesSpoken, payload);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e.response.data);
  }
}

function* createLanguageSpokenFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(createLanguageSpoken, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editLanguageSpokenFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { id, ...data } = payload;
    const { data: response } = yield call(editLanguageSpoken, id, data);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteLanguageSpokenFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(deleteLanguageSpoken, payload);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* verifyLanguageSpokenFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { id, names } = payload;
    const { data: response } = yield call(editLanguageSpoken, id, { status: VERIFIED, names });
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadCountriesFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data: response } = yield call(getCountries);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadCitiesFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(getCities, { country: payload });
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

export default function* () {
  yield all([
    takeLatest(DICTIONARIES_ACTION_TYPES.LOAD_BUSINESS_LINES, loadBusinessLinesFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.LOAD_PLAIN_BUSINESS_LINES, loadPlainBusinessLinesFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.CREATE_BUSINESS_LINE, createBusinessLineFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.EDIT_BUSINESS_LINE, editBusinessLineFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.DELETE_BUSINESS_LINE, deleteBusinessLineFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.VERIFY_BUSINESS_LINE, verifyBusinessLineFlow),

    takeLatest(DICTIONARIES_ACTION_TYPES.LOAD_INTERESTS, loadInterestsFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.LOAD_PLAIN_INTERESTS, loadPlainInterestsFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.CREATE_INTEREST, createInterestFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.EDIT_INTEREST, editInterestFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.DELETE_INTEREST, deleteInterestFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.VERIFY_INTEREST, verifyInterestFlow),

    takeLatest(DICTIONARIES_ACTION_TYPES.LOAD_LANGUAGES_SPOKEN, loadLanguagesSpokenFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.LOAD_PLAIN_LANGUAGES_SPOKEN, loadPlainLanguagesSpokenFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.CREATE_LANGUAGE_SPOKEN, createLanguageSpokenFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.EDIT_LANGUAGE_SPOKEN, editLanguageSpokenFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.DELETE_LANGUAGE_SPOKEN, deleteLanguageSpokenFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.VERIFY_LANGUAGE_SPOKEN, verifyLanguageSpokenFlow),

    takeLatest(DICTIONARIES_ACTION_TYPES.LOAD_COUNTRIES, loadCountriesFlow),
    takeLatest(DICTIONARIES_ACTION_TYPES.LOAD_CITIES, loadCitiesFlow),
  ]);
}
